<template>
  <!-- 员工类型变更 -->
  <div
    class="detail"
    v-show="dataDecrypt.action === 'U'"
  >
    <ax-panel :noTitle="true">
      <van-cell
        title="姓名"
        :value="dataDecrypt.header.emplid_description"
      ></van-cell>
      <van-cell
        title="变更原因"
        :value="dataDecrypt.header.action_reason_description"
      ></van-cell>
    </ax-panel>
    <!-- 原职务信息 -->
    <ax-panel title="原职务信息">
      <van-cell
        title="入司日期"
        :value="dataDecrypt.header.start_dt"
      ></van-cell>
      <van-cell
        title="员工类别"
        :value="dataDecrypt.header.empl_class_description"
      ></van-cell>
      <van-cell
        title="业务类型"
        :value="dataDecrypt.header.business_unit_description"
      ></van-cell>
      <van-cell
        title="部门"
        :value="dataDecrypt.header.deptid_description"
      ></van-cell>
      <van-cell
        title="职位"
        :value="dataDecrypt.header.qh_external_posn"
      ></van-cell>
      <van-cell
        title="序列"
        :value="dataDecrypt.header.jobcode_description"
      ></van-cell>
      <van-cell
        title="显示名称"
        :value="dataDecrypt.header.qh_outer_title"
      ></van-cell>
      <van-cell
        v-show="!dataDecrypt.header.qh_jobmanage_level_description"
        title="层级"
        :value="dataDecrypt.header.qh_major_level_description"
      ></van-cell>
      <van-cell
        v-show="dataDecrypt.header.qh_jobmanage_level_description"
        title="层级"
        :value="dataDecrypt.header.qh_jobmanage_level_description"
      ></van-cell>
      <van-cell
        v-show="dataDecrypt.header.qh_is_manager==='Y'"
        title="是否组织负责人"
        value="是"
      ></van-cell>
      <van-cell
        v-show="dataDecrypt.header.qh_expense_type_description"
        title="报销限额"
        :value="dataDecrypt.header.qh_expense_type_description"
      ></van-cell>
      <van-cell
        title="工作地点"
        :value="dataDecrypt.header.location_description"
      ></van-cell>
      <van-cell
        title="直接上级"
        :value="dataDecrypt.header.supervisor_id_description"
      ></van-cell>
      <van-cell
        title="公司"
        :value="dataDecrypt.header.company_description"
      ></van-cell>
    </ax-panel>
    <!-- 变更后职务信息 -->
    <ax-panel title="变更后职位信息">
      <van-cell
        title="变更日期"
        :value="dataDecrypt.qh_hr_006_hd01.start_dt"
      ></van-cell>
      <van-cell
        title="员工类别"
        :value="dataDecrypt.qh_hr_006_hd01.empl_class_description"
      ></van-cell>
      <van-cell
        title="业务类型"
        :value="dataDecrypt.qh_hr_006_hd01.business_unit_description"
      ></van-cell>
      <van-cell
        title="部门"
        :value="dataDecrypt.qh_hr_006_hd01.deptid_description"
      ></van-cell>
      <van-cell
        title="职位"
        :value="dataDecrypt.qh_hr_006_hd01.qh_external_posn"
      ></van-cell>
      <van-cell
        title="序列"
        :value="dataDecrypt.qh_hr_006_hd01.jobcode_description"
      ></van-cell>
      <van-cell
        title="显示名称"
        :value="dataDecrypt.qh_hr_006_hd01.qh_outer_title"
      ></van-cell>
      <van-cell
        v-show="!dataDecrypt.qh_hr_006_hd01.qh_jobmanage_level_description"
        title="层级"
        :value="dataDecrypt.qh_hr_006_hd01.qh_major_level_description"
      ></van-cell>
      <van-cell
        v-show="dataDecrypt.qh_hr_006_hd01.qh_jobmanage_level_description"
        title="层级"
        :value="dataDecrypt.qh_hr_006_hd01.qh_jobmanage_level_description"
      ></van-cell>
      <van-cell
        v-show="dataDecrypt.qh_hr_006_hd01.qh_is_manager==='Y'"
        title="是否组织负责人"
        value="是"
      ></van-cell>
      <van-cell
        v-show="dataDecrypt.qh_hr_006_hd01.qh_expense_type_description"
        title="报销限额"
        :value="dataDecrypt.qh_hr_006_hd01.qh_expense_type_description"
      ></van-cell>
      <van-cell
        title="工作地点"
        :value="dataDecrypt.qh_hr_006_hd01.location_description"
      ></van-cell>
    </ax-panel>
    <!-- 薪酬调整 -->
    <ax-panel
      title="薪酬调整"
      v-show="dataDecrypt.qh_hr_006_hd01.qh_pay_change==='Y'"
    >
      <van-cell
        title="绩效考核方案"
        :value="dataDecrypt.qh_hr_006_hd01.qh_epm_type_description"
      ></van-cell>
      <van-cell
        title="月基本工资"
        :value="dataDecrypt.qh_hr_006_hd01.qh_overall_salary"
      ></van-cell>
      <van-cell
        title="月度奖金"
        :value="dataDecrypt.qh_hr_006_hd01.qh_vary_pay"
      ></van-cell>
      <van-cell
        :title="dataDecrypt.field_special_deal.qh_year_pay_label"
        :value="dataDecrypt.qh_hr_006_hd01.qh_year_pay"
        v-show="dataDecrypt.field_special_deal.qh_year_pay_display==='Y'"
      ></van-cell>
      <van-cell
        style="border-bottom:none"
        v-show="dataDecrypt.field_special_deal.qh_year_pay_display==='Y'&&dataDecrypt.qh_hr_006_hd01.qh_year_pay!=0"
      >
        <p class="title">{{dataDecrypt.field_special_deal.qh_comment_label}}</p>
      </van-cell>
      <p
        class="desc"
        style="margin-bottom:20px"
        v-show="dataDecrypt.field_special_deal.qh_year_pay_display==='Y'&&dataDecrypt.qh_hr_006_hd01.qh_year_pay!=0"
      >{{dataDecrypt.qh_hr_006_hd01.qh_comment}}</p>
    </ax-panel>
    <!-- 是否特殊奖金 -->
    <!-- data.qh_hr_006_hd01.qh_is_special_bons	是否有特殊奖金 -->
    <ax-panel
      :noTitle="true"
      v-show="dataDecrypt.qh_hr_006_hd01.qh_is_cntr_end_bns==='Y'"
    >
      <van-cell
        title="签字费总额"
        :value="dataDecrypt.qh_hr_006_hd01.qh_sign_bonus"
      ></van-cell>
    </ax-panel>
    <ax-panel
      :noTitle="true"
      v-show="dataDecrypt.qh_hr_006_hd01.qh_is_cntr_end_bns==='Y'"
    >
      <van-cell
        title="发放节奏"
        :value="dataDecrypt.qh_hr_006_hd01.qh_pay_rhythm_description"
      ></van-cell>
    </ax-panel>
    <ax-panel
      :noTitle="true"
      v-show="dataDecrypt.qh_hr_006_hd01.qh_is_cntr_end_bns==='Y'"
    >
      <van-cell
        title="最低服务期"
        :value="dataDecrypt.qh_hr_006_hd01.qh_mini_ser_period_description"
      ></van-cell>
    </ax-panel>
    <!-- <ax-panel
      :noTitle="true"
      v-show="dataDecrypt.qh_hr_006_hd01.qh_is_cntr_end_bns==='Y'"
    >
      <van-cell
        title="满约奖金额"
        :value="dataDecrypt.qh_hr_006_hd01.qh_special_bonus"
      ></van-cell>
    </ax-panel> -->
    <ax-panel
      :noTitle="true"
      v-show="dataDecrypt.qh_hr_006_hd01.qh_is_special_bons==='Y'"
    >
      <van-cell
        title="特殊奖金金额"
        :value="dataDecrypt.qh_hr_006_hd01.qh_special_bonus"
      ></van-cell>
    </ax-panel>
    <!-- 特殊报销 -->
    <ax-panel
      title="特殊报销"
      v-show="dataDecrypt.qh_hr_006_hd01.qh_is_spec==='Y'"
    >
      <van-cell
        title="特殊报销金额"
        :value="dataDecrypt.qh_hr_006_hd01.qh_spec_reimb_sal"
      ></van-cell>
    </ax-panel>
    <!-- 其他激励 -->
    <!-- data.qh_hr_006_hd01.qh_is_stock	是否有其他激励 -->
    <!-- data.qh_hr_006_hd01.qh_stock_number	其他激励金额 -->
    <ax-panel
      title="其他激励"
      v-show="dataDecrypt.qh_hr_006_hd01.qh_is_stock==='Y'"
    >
      <van-cell
        title="其他激励金额 / 业务期权数量"
        :value="dataDecrypt.qh_hr_006_hd01.qh_stock_number"
      ></van-cell>
    </ax-panel>
    <!-- 其他说明 -->
    <ax-panel title="其他说明">
      <van-cell style="border-bottom:none">
        <p class="title">{{dataDecrypt.header.comments}}</p>
      </van-cell>
    </ax-panel>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js';
import watermark from '../../utils/warterMark';
import moment from 'moment';
export default {
  props: ['data'],
  data() {
    return {
      dataDecrypt: {
        header: {},
        field_special_deal: {}
      }
    };
  },
  watch: {
    data() {
      this.dataDecrypt = JSON.parse(this.Decrypt(this.data));
      console.log(1111, this.dataDecrypt);
      this.$emit('reciveData', this.dataDecrypt);
      // 水印
      this.$nextTick(() => {
        const name = this.dataDecrypt.current_user;
        const now = new Date();
        const date = `${now.getFullYear()}/${
          now.getMonth() + 1
        }/${now.getDate()} ${now.getHours()}:${
          now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes()
        }`;
        watermark.set(date + name);
      });

      if (this.dataDecrypt.action === 'V') {
        this.$dialog
          .alert({
            message: '已完成的审批暂时无法查询请知悉'
          })
          .then(() => {
            console.log('已审批');
          });
      }
    }
  },
  methods: {
    Decrypt(word) {
      //数据解密
      const key = CryptoJS.enc.Utf8.parse('A-16-Byte-keyVal');
      const iv = CryptoJS.enc.Utf8.parse('A-16-Byte-String');

      let encryptedHexStr = CryptoJS.enc.Base64.parse(word);
      let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
      let decrypt = CryptoJS.AES.decrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
      return decryptedStr.toString();
    }
  }
};
</script>
<style lang="scss" scoped>
.van-cell .van-cell__value {
  text-align: right;
  padding-right: 0.4rem;
}
.van-cell {
  border-bottom: 1px solid $border-color;
}
.base {
  border-bottom: none;
}
.van-cell__right-icon {
  // margin-left: -2.8rem;
  // float: right;
  position: absolute;
  right: 0.1rem;
}
.van-cell .van-cell__title {
  width: 4rem;
  // color:#000
}
.w100 .van-cell__title {
  width: 8rem;
}
.van-collapse-item__wrapper .van-collapse-item__content {
  color: rgba(0, 0, 0, 0.9);
}
.title {
  color: rgba(0, 0, 0, 0.3);
  // color: #000;
  font-size: 0.4rem;
  text-align: left;
  padding-left: 0.42667rem;
}
.desc {
  color: #ccc;
  padding-left: 25px;
  font-size: 0.35rem;
  text-align: left;
}
</style>